const getFetchParams = (state) => {
  let params = {}
  if (state.cursors && state.cursors.after) {
    params.after = state.cursors.after
  }
  if (state.postFilter) {
    params.filter = state.postFilter
  }
  if (state.postSort) {
    params.sortBy = state.postSort
  }
  return params
}

const isBlank = str => (!str || /^\s*$/.test(str))
const isNotBlank = str => !isBlank(str)

const convertFileToBase64 = (file, maxSize) => {
  let reader = new FileReader()
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort()
      reject(new DOMException('Problem parsing input file.'))
    }
    reader.onload = () => resolve(reader.result)
    if (file && file.size <= maxSize) {
      reader.readAsDataURL(file)
    }
  })
}

const validBase64SrcString = (image) => {
  if (image && image.visual) {
    if (image.visual.startsWith('data')) {
      return image.visual
    } else {
      return 'data:image/jpeg;base64,' + image.visual
    }
  }
  return null
}

export default {
  getFetchParams,
  isBlank,
  isNotBlank,
  convertFileToBase64,
  validBase64SrcString
}
